import { createSelector } from 'reselect';
import { State } from 'reducers';

const getDesignerState = (state: State) => state.designer;

export const isSavingReport =
    createSelector(
        getDesignerState,
        state => !!state && state.saving
    )
;

export const getDesignerError =
    createSelector(
        getDesignerState,
        state => state && state.error || null
    )
;

export const getReport =
    createSelector(
        getDesignerState,
        state => state && state.report || null
    )
;

export const isReportNew =
    createSelector(
        getDesignerState,
        state => !!state && state.isNew
    )
;



// WEBPACK FOOTER //
// ./src/selectors/designerSelectors.ts